import * as types from '../../mutation-types'

export default {

  [types.SET_CONNECT_USER_ID] (state, payload) {
    state.user.connectUserID = payload
  },
  [types.SET_CONNECT_USER_EMAIL] (state, payload) {
    state.user.connectUserEmail = payload
  },
  [types.LOGIN_FAILURE] (state) {
    state.pending = false
  },
  [types.IS_LOGGED] (state, payload) {
    state.isLogged = true
  },
  [types.SET_TOKEN_URL] (state, payload) {
    state.token = payload
  },
  [types.SET_INIT_SEARCH] (state, payload) {
    state.initSearch = payload
  },
  [types.SET_INSIDE_IFRAME] (state, payload) {
    state.insideIframe = payload
  },
  [types.SET_ID_ENTREPRISE] (state, payload) {
    if (payload === null) {
      state.idEntreprise = null
    } else state.idEntreprise = Number(payload)
  },
  [types.SET_ID_PLATEFORME] (state, payload) {
    if (payload === null) {
      state.idPlateforme = null
    } else state.idPlateforme = Number(payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js